import AdAccount from '@/entities/AdAccount.js';
import ProductCatalogue from '@/entities/ProductCatalogue.js';
import api from '@/services/Api';

export default {
  connect(platform, id) {
    const data = {
      platform,
      id,
    };

    return api().post('/ad-account', data)
      .then(resp => new AdAccount(resp));
  },

  disconnect(id) {
    return api().delete('/ad-account/' + id);
  },

  refresh(id) {
    return api().post('/ad-account/' + id + '/refresh')
      .then(resp => new AdAccount(resp));
  },

  update(entity) {
    return api().put('/ad-account/' + entity.id, entity.toObject())
      .then(resp => new AdAccount(resp));
  },

  getProductCatalogues(id) {
    return api().get('/ad-account/' + id + '/product-catalogues')
      .then(resp => resp.map(item => new ProductCatalogue(item)));
  },

  updateSpendCap(id, spendCap) {
    return api().put('/ad-account/' + id + '/spend-cap', { spend_cap: spendCap });
  },

  deleteSpendCap(id) {
    return api().delete('/ad-account/' + id + '/spend-cap');
  },

  refreshProductCatalogs(id) {
    return api().post('/ad-account/' + id + '/product-catalogues/refresh')
      .then(resp => resp.map(item => new ProductCatalogue(item)));
  },
};
